import React from 'react';
import { useLanguage } from '../LanguageContext';
import useLanguageRouting from '../useLanguageRouting';

const LanguageToggle = () => {
  const { lang, t } = useLanguage();
  const { switchLanguage } = useLanguageRouting();

  return (
    <button
      type="button"
      onClick={switchLanguage}
      className="theme-toggle lang-toggle"
      aria-label={t.switchLabel}
      title={t.switchLabel}
    >
      {lang === 'en' ? 'PL' : 'EN'}
    </button>
  );
};

export default LanguageToggle;
